<script>
  import { search_black_png } from '../image-base64'
  import { createEventDispatcher } from 'svelte'
  import { onMount } from 'svelte'

  export let searchText = ''

  const dispatch = createEventDispatcher()

  let ref

  onMount(() => {
    // It makes window scroll to have input visible :(
    // ref.focus()
  })

  function keyPressed (key) {
    if (key.key !== 'Enter') {
      return
    }
    dispatch('search', searchText)
  }
</script>

<div class="search-box relative border-0 text-lg w-auto" style="max-width: 500px">
  <input id="search-input" type="search" placeholder="Enter your search term here ..."
         class="rounded-md py-3 pr-12 pl-4 border-0 font-light w-full"
         bind:this={ref}
         bind:value={searchText}
         on:keyup={keyPressed}
  />

  <div
         class="search-label absolute right-0 mr-3 cursor-pointer"
         style="background-image: url({search_black_png})"
         on:click={() => dispatch('search', searchText)}
  ></div>
</div>

<style>
    #search-input {
        border: 1px #e0e0e0 solid;
    }

    #search-input:focus {
        border: 1px #222222 solid;
    }

    .search-label {
        width: 18px;
        height: 18px;
        top: 50%;
        margin-top: -9px;
    }
</style>